module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_03-c3c42afbfc77c7f50e16d4705db495ea.jpg";